export default __webpack_public_path__ + "static/media/write.8859d960.svg";